import { AdvancedSelect } from 'components/AdvancedSelect'
import { getAccessToken } from 'helpers/getAccessToken'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

export function ActividadMultiSelect(props) {
    const [actividades, setActividades] = useState([{ id: 1, descripcion: 'Foo' }])

    useEffect(() => {
        const load = async () => {
            try {
                const token = getAccessToken()
                const response = await fetch(`${process.env.REACT_APP_API_URL}/clase/actividades`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                const data = await response.json()
                if (response.ok) {
                    setActividades(data)
                } else {
                    toast.error('Ocurrió un error al obtener las actividades')
                }
            } catch (error) {
                toast.error('Ocurrió un error en el servidor')
            }
        }
        load()
    }, [])

    return <AdvancedSelect optionValue='id' optionLabel='descripcion' {...props} options={actividades} />
}
